export default __webpack_public_path__ + "fonts/hammer-and-brush.svg";